'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var formField = require('./form-field-568b9a9c.js');
require('./messages-f8f39369.js');

var Input = function (props) { return (React__default.createElement(formField.FormField, tslib_es6.__assign({ fieldType: formField.FormFieldType.INPUT }, props))); };

exports.Input = Input;
